var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CodeEditor',{attrs:{"withButton":false,"label":this.$t('code'),"label-cols":1,"options":{
                mode: 'javascript', 
                showFullscreenButton: true,
                title: _vm.nodeName,
                enableProtokolTypes: true  // This will load Protokol SDK types
            },"height":_vm.editorHeight},model:{value:(_vm.content.expression),callback:function ($$v) {_vm.$set(_vm.content, "expression", $$v)},expression:"content.expression"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }